var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.checkBanner())?_c('div',{staticClass:"pm_list_banner",style:(`background-image : url(${_vm.returnThumbnail()})`)}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }